import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";

export class Translation {
    private static _texts: any;

    public static init(gameTexts: any) {
        Translation._texts = gameTexts;
    }

    public static getText(key: string) {
        return Translation._texts[GameVars.gameData.language || GameConstants.LANG_EN][key];
    }
}